import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface'
import {
  ECourseTabEnum,
  tabLocoKeys,
} from 'modules/stores/store/content/product/digital-product/product-e-course/enum/e-course-tab-enum'
import { getCourseError } from 'modules/stores/store/content/product/digital-product/product-e-course/utils/get-course-error'
import { ProductECourseItemErrorsType } from 'modules/stores/store/content/product/types/product-interface'
import {
  getDigitalProductCheckoutErrorChecker,
  getOptionsErrorChecker,
  getThankYouErrorChecker,
  getThumbnailErrorChecker,
} from 'modules/stores/store/utils/get-error-checkers'
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs'

export const useErrorMessageInTabs = () => {
  const { formErrorMessage: formErrorMessageCommon } = useFormErrorMessageInTabs()

  const getTabsWithErrors = ({
    errors,
    digitalProductErrors,
  }: {
    errors: ProductECourseItemErrorsType
    digitalProductErrors: DigitalProductErrorInterface
  }): Record<ECourseTabEnum, boolean> => {
    const hasThumbnailError = getThumbnailErrorChecker(errors)

    const hasCheckoutError = getDigitalProductCheckoutErrorChecker(errors, digitalProductErrors)

    const hasThankYouError = getThankYouErrorChecker(errors)

    const hasCourseError = getCourseError(errors)

    const hasOptionsError = getOptionsErrorChecker(digitalProductErrors)

    return {
      [ECourseTabEnum.course]: hasCourseError,
      [ECourseTabEnum.options]: hasOptionsError,
      [ECourseTabEnum.thumbnail]: hasThumbnailError,
      [ECourseTabEnum.checkout]: hasCheckoutError,
      [ECourseTabEnum.thank_you]: hasThankYouError,
    }
  }

  const formErrorMessage = ({
    errors,
    digitalProductErrors,
  }: {
    errors: ProductECourseItemErrorsType
    digitalProductErrors: DigitalProductErrorInterface
  }) => {
    const tabsErrorsMap = getTabsWithErrors({ errors, digitalProductErrors })
    return formErrorMessageCommon({ tabsErrorsMap, tabsLocoKeys: tabLocoKeys })
  }

  return {
    getTabsWithErrors,
    formErrorMessage,
  }
}
